import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthenticationService } from 'src/app/core/services/authentication.service';
import { environment } from 'src/environments/environment';
import { RouteBean } from '../model/RouteBean';
import { Observable, throwError } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';
import { RouteBeanToSave } from '../model/RouteBeanToSave';

@Injectable({
  providedIn: 'root'
})
export class AdministrationService {
  //infrefLocal = new RouteBean();
  headers = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    }),
  };
  constructor(
    private http: HttpClient,
    private authenticationService: AuthenticationService
  ) { }

  getAdministration(): Promise<any[]> {
    let user = this.authenticationService.getCurrentUser();
    let path = `${environment.adminApiUrl}routes`;

    return (
      this.http
        .get<any>(path)
        .pipe(catchError(this.handleError))
        .toPromise()
        .then((res) => res)
        .then((data) => {
          return data;
        })
        .catch((ex) => {
          console.error('Error fetching routes', ex);
        })
    );
  }

  getuserSystems(): Promise<any[]> {
    let user = this.authenticationService.getCurrentUser();
    let path = `${environment.adminApiUrl}userSystems`;

    return (
      this.http
        .get<any>(path)
        .pipe(catchError(this.handleError))
        .toPromise()
        .then((res) => res)
        .then((data) => {
          return data;
        })
        .catch((ex) => {
          console.error('Error fetching routes', ex);
        })
    );
  }

  getSystemNames(): Promise<any[]> {
    let user = this.authenticationService.getCurrentUser();
    let path = `${environment.adminApiUrl}systemNames`;

    return (
      this.http
        .get<any>(path)
        .pipe(catchError(this.handleError))
        .toPromise()
        .then((res) => res)
        .then((data) => {
          return data;
        })
        .catch((ex) => {
          console.error('Error fetching routes', ex);
        })
    );
  }

  getchannelTypes(): Promise<any[]> {
    let user = this.authenticationService.getCurrentUser();
    let path = `${environment.adminApiUrl}channelTypes`;

    return (
      this.http
        .get<any>(path)
        .pipe(catchError(this.handleError))
        .toPromise()
        .then((res) => res)
        .then((data) => {
          return data;
        })
        .catch((ex) => {
          console.error('Error fetching routes', ex);
        })
    );
  }

  private handleError(error: HttpErrorResponse) {
    console.log(error.error);
    if (error.status === 0) {
      // A client-side or network error occurred. Handle it accordingly.
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong.
      console.error(
        `Backend returned code ${error.status}, body was: `,
        error.error
      );
    }
    // Return an observable with a user-facing error message.
    return throwError('Something bad happened; please try again later.');
  }


  updateInfref(infRef: RouteBeanToSave): Promise<any> {
    let user = this.authenticationService.getCurrentUser();
    return (
      this.http
        .put<any>(
          `${environment.adminApiUrl}routes/${infRef.systemUUID}`,
          infRef,
          this.headers
        )
        .pipe(catchError(this.handleError))
        .toPromise()
        .then((data) => {
          return data;
        })
    );
  }

  addInfRef(infRef: RouteBeanToSave): Promise<any> {
    let user = this.authenticationService.getCurrentUser();
    return (
      this.http
        .post<any>(
          `${environment.adminApiUrl}routes`,
          infRef,
          this.headers
        )
        .pipe(catchError(this.handleError))
        .toPromise()
        .then((data) => {
          return data;
        })
    );
  }

  deleteInfref(routeId: any): Promise<any> {
    let user = this.authenticationService.getCurrentUser();
    return (
      this.http
        .delete<any>(
          `${environment.adminApiUrl}routes/${routeId}`,
          this.headers
        )
        .pipe(catchError(this.handleError))
        .toPromise()
        .then((data) => {
          return data;
        })
    );
  }
}